import { render, staticRenderFns } from "./auth-backend-error.vue?vue&type=template&id=54d8525f&"
import script from "./auth-backend-error.vue?vue&type=script&lang=js&"
export * from "./auth-backend-error.vue?vue&type=script&lang=js&"
import style0 from "./auth-backend-error.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports